import FadeInUp from '../../../components/FadeInUp';
import useIsMobile from '../../../hook/useIsMobile';

export default function DeviceUsage() {

  const isMobile = useIsMobile();

  const data = [
    {
      "index": 1,
      "title": "누르기만 하면 구조 요청",
      "description": "응급 상황 발생 시, 버튼 한 번으로\n신고부터 취소까지 간편하게 처리합니다."
    },
    {
      "index": 2,
      "title": "전동차 어디든 설치",
      "description": "구조나 형태와 관계없이\n원하는 위치에 도구 없이 간편하게 부착 가능합니다."
    },
    {
      "index": 3,
      "title": "LED 상태 표시등",
      "description": "상태를 비추는 LED\n야간 사고에도 눈에 띕니다."
    },
    {
      "index": 4,
      "title": "충전 없이 간편하게",
      "description": "AA 알카라인 건전지로 최대 6개월 사용\n매일 충전할 필요가 없습니다."
    },
  ];

  return (
    <section className='top-space wrapper'>
      <FadeInUp>
        <h2 className='font-bold text-title2 lg:text-display2'>
          링콜만의 솔루션으로<br/>
          고객을 보호합니다
        </h2>
      </FadeInUp>

      <div>
        {
          data.map((item, idx) => (
            <div
              key={idx}
              className={`mt-[60px] flex flex-col gap-[24px] lg:gap-[80px] justify-between ${!isMobile && idx % 2 === 0 ? 'lg:flex-row-reverse' : 'lg:flex-row'}`}
            >
              <FadeInUp
                delay={0.3}
                className='w-full lg:w-1/2'
              >
                <img 
                  className='w-full aspect-square rounded-[16px] lg:rounded-[20px]'
                  alt='이미지'
                  src={`${process.env.REACT_APP_STATIC_URL}/images/main/device_usage${item.index}.jpg`}
                />
              </FadeInUp>
              <FadeInUp className='flex-1 flex flex-col items-start justify-center'>
                <div className='text-title3 lg:text-title1 font-bold'>{item.title}</div>
                <div className='text-body1 lg:text-heading1 text-label-300 whitespace-pre-line mt-[8px] lg:mt-[20px]'>{item.description}</div>
              </FadeInUp>
            </div>
          ))
        }
      </div>
    </section>
  )
}